<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BqyhC3/tc-custom/9780830898251.jpg?1696024731316" alt="This image is the cover for the book Psalms, Tyndale Old Testament Commentaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Psalms, Tyndale Old Testament Commentaries
      </h1>
      <p class="bookDescription body article font2">
        <p>The book of Psalms is the heart of the Old Testament, the libretto of the most vibrant worship imaginable. It informs our intellect, stimulates our imagination, arouses our emotions and stirs us to holy thoughts and actions. It is also a pivotal witness to, and anticipation of, Jesus Christ. Tremper Longman?s commentary interprets each psalm in its Old Testament setting, summarizes its message and reflects on its significance from a New Testament perspective, providing a christological reading. The Tyndale Old Testament Commentaries have long been a trusted resource for Bible study. Written by some of the world's most distinguished evangelical scholars, these twenty-eight volumes offer clear, reliable and relevant explanations of every book in the Old Testament, aiming to get at the true meaning of the Bible and to make its message plain to readers today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tremper Longman III
      </h2>
      
      <p class="authorDescription body article"><p>Tremper Longman III (PhD, Yale University) is Robert H. Gundry Professor of Biblical Studies at Westmont College in Santa Barbara, California. He is also visiting professor of Old Testament at Seattle School of Theology and Psychology and adjunct of Old Testament at Fuller Theological Seminary. He lectures regularly at Regent College in Vancouver and the Canadian Theological Seminary in Calgary. Longman is the author or coauthor of over twenty books, including<em>How to Read Genesis, How to Read the Psalms, How to Read Proverbs, Literary Approaches to Biblical Interpretation, Old Testament Essentials</em> and coeditor of <em>A Complete Literary Guide to the Bible.</em> He and Dan Allender have coauthored <em>Bold Love, Cry of the Soul, Intimate Allies, The Intimate Mystery</em> and the Intimate Marriage Bible studies.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69ad1b7a